/* eslint-disable */
export default [
  {
    path: "/activity/:id",
    name: "Activity",
    props: true,
    component: () =>
      import(/* webpackChunkName: "List" */ "@/views/activity/List.vue"),
    meta:{
      requiresAuth: true,
      roles: ['AulaVirtual']
    },
  },
  {
    path: "/activity/:id/:type",
    name: "ActivityType",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "TypeActivity" */ "@/views/activity/TypeActivity.vue"
      ),
    meta:{
      requiresAuth: true,
      roles: ['AulaVirtual']
    },
  },
];
